import { render } from "./PageNotFound.vue?vue&type=template&id=057d1b7e&scoped=true&ts=true"
import script from "./PageNotFound.vue?vue&type=script&lang=ts"
export * from "./PageNotFound.vue?vue&type=script&lang=ts"

import "./PageNotFound.vue?vue&type=style&index=0&id=057d1b7e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-057d1b7e"]])

export default __exports__